module.exports = __webpack_public_path__ + "img/h4.2a998834.png";